/
<!--==================================================
    component name  : 廣告橫幅
    author          : Samma
    last update     : 2020-05-05
    use description : 
==================================================-->
<template>
  <section id="newa" :class="adBannerClass">
    <!--普通模式-->
    <carousel
      class="d-none d-lg-block"
      :perPageCustom="[
        [0, 1],
        [768, 1],
        [1024, 1],
      ]"
      :autoplay="true"
      :autoplayTimeout="5000"
      :loop="true"
      paginationActiveColor="#ff6c00"
    >
      <slide v-for="(banner, index) in banners" v-bind:key="index">
        <a
          v-if="banner.url && banner.url.length > 0"
          :href="banner.url"
          target="_blank"
        >
          <img :src="banner.img_pc" alt="OWLocker智慧型寄物櫃" />
        </a>
        <img v-else :src="banner.img_pc" alt="OWLocker智慧型寄物櫃" />
      </slide>
    </carousel>

    <!--手機-->
    <carousel
      class="d-lg-none"
      :perPageCustom="[
        [0, 1],
        [768, 1],
        [1024, 1],
      ]"
      :autoplay="true"
      :autoplayTimeout="5000"
      :loop="true"
      paginationActiveColor="#ff6c00"
    >
      <slide v-for="(banner, index) in banners" v-bind:key="index">
        <a
          v-if="banner.url && banner.url.length > 0"
          :href="banner.url"
          target="_blank"
        >
          <img :src="banner.img_mobile" alt="OWLocker智慧型寄物櫃" />
        </a>
        <img v-else :src="banner.img_mobile" alt="OWLocker智慧型寄物櫃" />
      </slide>
    </carousel>

    <!--開始播放廣告的貓頭鷹-->
    <div
      v-if="ad_type == 'querysite'"
      class="locationA4"
      @click="vCloseAdBanner()"
    >
      <img
        class="img-fluid"
        src="../assets/images/owl_ad.svg"
        alt="OWLocker智慧型寄物櫃"
      />
    </div>
  </section>
</template>

<script>
import Public from '@/scripts/public';
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'AdBanners',
  props: {
    ad_type: String,
  },
  components: {
    Carousel,
    Slide,
  },
  data: function () {
    return {
      banner_api: Public.appGetAPIURL('ad'),
      ad_open: false,
      //廣告資源 (預設值為初始資源)
      banners: [
        {
          img_pc: './img/default/slide4.jpg',
          img_mobile: './img/default/slide4s.jpg',
          url: null,
        },
        {
          img_pc: './img/default/slide2.jpg',
          img_mobile: './img/default/slide2s.jpg',
          url: null,
        },
      ],
    };
  },
  computed: {
    adBannerClass: function () {
      return {
        locbanner: this.ad_type == 'querysite' ? true : false,
        show: this.ad_type == 'querysite' && this.ad_open ? true : false,
      };
    },
  },
  mounted: function () {
    //從 cache / 網路載入廣告資源
    this.vLoadBanner();
  },
  methods: {
    //從cache / 網路載入廣告資源
    vLoadBanner: function () {
      var ref = this;
      // 從 chaches 取得
      Public.appGetOWLockerDataFromCache(this.banner_api).then((data) => {
        ref.vRenderBanner(data);
      });

      // // 從網路取得
      Public.appGetOWLockerDataFromNetwork(this.banner_api).then((data) => {
        ref.vRenderBanner(data);
      });
    },
    vRenderBanner: function (banners_data) {
      //重置資料
      this.banners =
        banners_data && banners_data.length > 0 ? banners_data : this.banners;
    },
    vToggleAdBanner: function (ad_open) {
      this.ad_open = ad_open;
    },
    vCloseAdBanner: function () {
      this.ad_open = !this.ad_open;
      this.$emit('close-ad-banner', this.ad_open);
    },
  },
};
</script>
